import React, { useEffect, useState } from "react";
import { TestimonialTabs } from "../../constants";
import {
  AddFlex,
  PrimaryActionButton,
  SecondaryActionButton,
} from "../../reusableStyles";
import { Dialog } from "@mui/material";
import TestimonialsHeader from "../../Testimonials/TestimonialsHeader";
import { useSelector } from "react-redux";
import { isNullOrUndefined } from "../../utils";
import TestimonialsHolder from "../../Testimonials/TestimonialsHolder";
import useWindowSize from "../../Hooks/useWindowSize";
import LeftBorderContentHeader from "../LeftBorderContentHeader";
import { GetUserTestimonials } from "../../Api/ApiEndPoints";
import { callNonStoreApi } from "../../NonStoreApis";
import { setUserTestimonialsAction } from "../../Store/appTempSlice";
import { useDispatch } from "react-redux";

function OfferingTestimonials({ handleSetOffering, offeringTestimonials }) {
  const dispatch = useDispatch();
  const [testimonials, setTestimonials] = useState([]);
  const [openTestimonialsDialog, setOpenTestimonialsDialog] = useState(false);
  const [selectedTab, setSelectedTab] = useState(TestimonialTabs.ALL);

  const [selectedTestimonials, setSelectedTestimonials] =
    useState(offeringTestimonials);
  const { isMobileView } = useWindowSize();

  const _testimonials = useSelector((state) => state.appTemp.data.testimonials);

  const [mainTestimonials, setMainTestimoniasl] = useState({
    [TestimonialTabs.ALL]: [],
    [TestimonialTabs.SELF]: [],
    [TestimonialTabs.PUBLIC]: [],
  });

  const handleMainTestimonialFilter = (selectedTab) => {
    if (selectedTab === TestimonialTabs.ALL) {
      setAllTestimonials();
    } else if (selectedTab === TestimonialTabs.SELF) {
      setTestimonials(
        _testimonials.filter(
          (testimonial) => testimonial.source === TestimonialTabs.SELF
        )
      );
    } else {
      setTestimonials(
        _testimonials.filter(
          (testimonial) => testimonial.source === TestimonialTabs.PUBLIC
        )
      );
    }
  };

  const handleSearchFilter = (searchText) => {
    if (searchText.length === 0) {
      setAllTestimonials();
      return;
    }
    setTestimonials((prev) =>
      prev.filter((testimonial) => {
        if (
          isNullOrUndefined(testimonial.msg) &&
          isNullOrUndefined(testimonial.name)
        ) {
          return false;
        } else if (isNullOrUndefined(testimonial.name)) {
          return testimonial.msg.toLowerCase().includes(searchText);
        } else if (isNullOrUndefined(testimonial.msg)) {
          return testimonial.name.toLowerCase().includes(searchText);
        }
        return (
          testimonial.msg.toLowerCase().includes(searchText) ||
          testimonial.name.toLowerCase().includes(searchText)
        );
      })
    );
  };
  // const getFeatures
  const setAllTestimonials = () => {
    if (isNullOrUndefined(_testimonials)) return [];
    setTestimonials(_testimonials);
  };

  const handleToggleCheckbox = (testimonialId) => {
    if (selectedTestimonials.includes(testimonialId)) {
      setSelectedTestimonials((prevFilters) =>
        prevFilters.filter((_filter) => _filter !== testimonialId)
      );
    } else {
      setSelectedTestimonials((prev) => [...prev, testimonialId]);
    }
  };

  useEffect(() => {
    setAllTestimonials();
  }, []);

  useEffect(() => {
    setSelectedTab(selectedTab);
    const testimonials = {
      [TestimonialTabs.ALL]: [],
      [TestimonialTabs.SELF]: [],
      [TestimonialTabs.PUBLIC]: [],
    };
    callNonStoreApi(GetUserTestimonials).then((response) => {
      dispatch(setUserTestimonialsAction(response.data.docs));
      response.data.docs?.forEach((element) => {
        const source = element.source || TestimonialTabs.SELF;
        testimonials[source].push(element);
      });
      testimonials[TestimonialTabs.ALL] = response.data.docs;
    });

    setMainTestimoniasl(testimonials);
  }, []);

  const getTestimonialsLength = () => {
    return _testimonials?.filter((item) =>
      selectedTestimonials.includes(item.id)
    ).length;
  };

  return (
    <>
      <LeftBorderContentHeader
        headerText={"Testimonials"}
        subText={"This is an optional section"}
      />
      <AddFlex flexDirection="column">
        {getTestimonialsLength() > 0 ? (
          <AddFlex
            alignItems="flex-start"
            // padding="10px"
            style={{
              gap: "10px",
            }}
          >
            {getTestimonialsLength()}{" "}
            {getTestimonialsLength() === 1 ? "Testimonial" : "Testimonials"}{" "}
            Added
          </AddFlex>
        ) : (
          "No Testimonials Added"
        )}
      </AddFlex>
      <AddFlex margin="15px 0 0 0">
        <SecondaryActionButton
          borderRadius="5px"
          onClick={() => setOpenTestimonialsDialog((prev) => !prev)}
        >
          Manage Testimonials
        </SecondaryActionButton>
      </AddFlex>
      <Dialog
        open={openTestimonialsDialog}
        onClose={() => setOpenTestimonialsDialog((prev) => !prev)}
        PaperProps={{
          sx: {
            width: isMobileView() ? "95vw" : "80vw",
            height: "90vh",
            maxWidth: "100vw",
          },
        }}
      >
        <AddFlex
          flexDirection="column"
          padding="0 30px"
          style={{ borderBottom: "1px solid #ddd" }}
        >
          <TestimonialsHeader
            selectedTab={selectedTab}
            mainTestimonials={mainTestimonials}
            testimonials={_testimonials}
            handleMainTestimonialFilter={handleMainTestimonialFilter}
            handleSearchFilter={handleSearchFilter}
            hideExtraFilters={true}
          />
        </AddFlex>
        <AddFlex
          height="80%"
          style={{ overflowY: "scroll", overflowX: "hidden" }}
          // justify="center"
          padding={isMobileView() ? "10px" : "30px"}
        >
          <TestimonialsHolder
            testimonials={testimonials}
            isOfferingDialog={true}
            selectedTestimonials={selectedTestimonials}
            onTestimonialClicked={(id) => {
              handleToggleCheckbox(id);
            }}
          />
        </AddFlex>
        <AddFlex
          position="absolute"
          bottom="0px"
          right="0"
          width={"100%"}
          padding="10px 30px"
          backgroundColor="white"
          style={{
            zIndex: "1111",
            boxShadow: "0 0 0px 4px rgba(0,0,0,0.05)",
          }}
        >
          <PrimaryActionButton
            margin="0 auto"
            type="submit"
            onClickCapture={() => {
              handleSetOffering("testimonials.data", selectedTestimonials);
              setOpenTestimonialsDialog((prev) => !prev);
            }}
          >
            Add Testimonials
          </PrimaryActionButton>
        </AddFlex>
      </Dialog>
    </>
  );
}

export default OfferingTestimonials;
